let FundamentalTabReportType  = {
  Income: 1,
  Balancesheet: 2,
  Cashflow: 3,
  Ratios: 4,
  Wondastockreport: 5
}
export default FundamentalTabReportType;